import React from 'react'
import { Box, Checkbox } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/styles'
import { SelectCell, selectionColumnId, toMuiTheme } from 'core/table/table-hooks/useSelectColumn'
import { useMessagesServerSideSelectionContext } from 'messages/context/MessagesServerSideSelectionContext'

const ServerSideSelectHeader = () => {
  const { totalCount, selectedCount, selectingAll, listLoading, onSelectAllMatching, onClearSelection } =
    useMessagesServerSideSelectionContext()

  const allMatchingSelected = totalCount > 0 && selectedCount === totalCount
  const indeterminate = selectedCount > 0 && selectedCount < totalCount

  return (
    <ThemeProvider theme={toMuiTheme}>
      <Checkbox
        checked={allMatchingSelected}
        indeterminate={indeterminate}
        disabled={selectingAll || listLoading || totalCount === 0}
        onChange={() => {
          if (allMatchingSelected) {
            onClearSelection()
          } else {
            onSelectAllMatching()
          }
        }}
      />
    </ThemeProvider>
  )
}

export const useServerSideMessagesSelectColumn =
  (
    predicate: (row: { original: unknown }) => boolean,
    className: string | undefined,
    getInnerClass: (row: { original: unknown }) => string = () => '',
  ) =>
  (hooks: any) => {
    const selectColumn = {
      id: selectionColumnId,
      Header: ServerSideSelectHeader,
      Cell: ({ row }: { row: { original: unknown } }) => {
        const isEnabled = predicate(row)

        return (
          <div className={getInnerClass(row)}>
            {isEnabled ? <SelectCell row={row} /> : <Box width={42} height={42} />}
          </div>
        )
      },
      className,
    }

    hooks.visibleColumns.push((columns: any[]) => [selectColumn, ...columns])
  }
